import React from "react";
import TitleValueCell from "./TitleValueCell";
import CurrencyToggle from "./CurrencyToggle";

interface PaymentCurrencySelectorProps {
  title: string;
  baseCurrencyCode: string;
  localCurrencyCode: string;
  isLocalSelected: boolean;
  onChange: (isLocal: boolean) => void;
}

const PaymentCurrencySelector: React.FC<PaymentCurrencySelectorProps> = ({
  title,
  baseCurrencyCode,
  localCurrencyCode,
  isLocalSelected,
  onChange,
}) => (
  <TitleValueCell
    leftTextValue={title}
    rightValueChildren={
      <CurrencyToggle
        baseCurrencyCode={baseCurrencyCode}
        localCurrencyCode={localCurrencyCode}
        isLocalSelected={isLocalSelected}
        onChange={onChange}
        testIdPrefix="payment-currency-toggle"
      />
    }
  />
);

export default PaymentCurrencySelector;
